// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#bbb-file-action button.success {\n  background-color: var(--color-success);\n  border-color: var(--color-success-hover);\n  color: var(--color-primary-text); }\n  #bbb-file-action button.success:hover {\n    background-color: var(--color-success-hover); }\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
